import  gql  from 'graphql-tag'

export const groups = gql`query groups{ 
    groups{
        edges{
            node{
                id
                name
                permissions{
                    edges{
                        node{
                            id
                            name
                        }
                    }
                }
            }
        }
    }
}`;
